import { render, staticRenderFns } from "./PackingTabs.vue?vue&type=template&id=3fc063b4&scoped=true&"
import script from "./PackingTabs.vue?vue&type=script&lang=js&"
export * from "./PackingTabs.vue?vue&type=script&lang=js&"
import style0 from "./PackingTabs.vue?vue&type=style&index=0&id=3fc063b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc063b4",
  null
  
)

export default component.exports